<template>
    <el-card class="lesson-resources-links" shadow="never">
        <div class="outlink">
            <el-row class="outlink-block" v-for="item in pageSize" :key="item">
                <el-col :span="23">
                    <h3 class="outlink-title">百度翻译 - [工具]</h3>
                    <a class="outlink-content" href="https://fanyi.baidu.com" target="_blank">https://fanyi.baidu.com</a>
                    <p class="outlink-info">
                        <time class="outlink-time">19/04/25&nbsp;&nbsp;&nbsp;09:03编辑</time>
                    </p>
                </el-col>
                <el-col class="outlink-action" :span="1">
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>编辑</el-dropdown-item>
                            <el-dropdown-item>删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
            <div class="pagination">
                <el-pagination hide-on-single-page
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            :pager-count="pagerCount"
                            :total="totalEnclosure"
                            @size-change="sizeChange"
                            @current-change="currentChange">
                </el-pagination>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    data () {
        return {
            currentPage: 1, // 当前页数，支持 .sync 修饰符
            pageSize: 10, // 每页显示条目个数，支持 .sync 修饰符
            pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            totalEnclosure: 100, // 总条目数
        }
    },
    methods: {
        // pageSize 改变时会触发
        sizeChange (pageSize) {
            this.pageSize = pageSize
        },
        // currentPage 改变时会触发
        currentChange (currentPage) {
            this.currentPage = currentPage
        }
    }
}
</script>


<style lang="less" scoped>
.lesson-resources-links {
    .outlink {
        .pagination {
            text-align: center;
            margin-top: 20px;
        }
        &-block {
            line-height: 1em;
            margin-top: 15px;
            padding-bottom: 10px;
            border-bottom: 1px solid #d0d0d0;
            &:first-child {
                margin-top: 0;
            }
        }
        &-action {
            text-align: right;
        }
        &-title {
            font-size: 18px;
            font-weight: normal;
            color: #333;
        }
        &-content {
            margin: 1em 0;
            color: #888;
            display: block;
        }
        &-info {
            font-size: 12px;
            color: #999;
        }
        &-time {}
    }
}
</style>
